import React, { useState,useEffect } from "react";
import axios from "axios";
import { API_URL,RESPONSE_SUCCESS,REQUEST_NOT_FOUND } from './../GlobalConstents.js';
import { Link, useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { toast } from 'react-toastify';
import * as trans from '../FrontMessages';
import { ROUTE_SIGN_IN } from '../RouteConstents';

const ForgotPassword = () => {

    const navigate = useNavigate();

    const { register, handleSubmit, formState: { errors } } = useForm();
    const [phone, setPhone] = useState('');
    
    useEffect(
        () => {
        document.body.classList.add('login-page');
    });  
 
    const onSubmit = async (data) => {
        
        let loginValue = { "email" : data.email,"password" : data.password };
        await axios.post(API_URL+'login',loginValue).then(function (response) {
            if (response.status === RESPONSE_SUCCESS) {
                if(response.data.status == true) {
                    toast.success(response.data.message); 
                    
                    if(response.data.is_verified == 1) {
                        localStorage.setItem("userInfo", JSON.stringify(response.data.userInfo));
                        
                        navigate('/dashboard');
                    } else {
                        navigate('/dashboard');   
                    }
                } else {
                   toast.error(response.data.message); 
                }
            }
        
        }).catch(function (error) {
            toast.error(error.message);
        });
        
    }

    return (
        <div style={{ backgroundColor: '#00BCD4' }}>
            
            <div className="login-box">
                <div className="logo">
                    <img src="./assets/images/logo.png" alt="SBS" width="100" />
                </div>
                <div className="card ">
                    <div className="body">
                        <form id="sign_in" method="POST">
                            <br/>
                            <div className="input-group">
                                <div className="form-line">
                                    <input type="text" className="form-control" name="phone" placeholder="Phone" required autoFocus />
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-xs-12 text-center">
                                    <button className="btn bg-pink waves-effect" type="submit">Send OTP</button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <div className="footer_login">
                <p><Link to={ROUTE_SIGN_IN}>Sign In</Link></p>
            </div>
        </div>
    );
   
}
    
export default ForgotPassword;